import { render, staticRenderFns } from "./NotificationHome.vue?vue&type=template&id=5eaad51a&scoped=true"
import script from "./NotificationHome.vue?vue&type=script&lang=js"
export * from "./NotificationHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eaad51a",
  null
  
)

export default component.exports